__turbopack_context__.v({
  "learnMore": "NewsletterBanner-module__bH0y1G__learnMore",
  "newsletterBanner": "NewsletterBanner-module__bH0y1G__newsletterBanner",
  "newsletterBannerSection": "NewsletterBanner-module__bH0y1G__newsletterBannerSection",
});
